import React from 'react';
import { func } from 'prop-types';
import { ListContentContainer } from '../LuContent.styles';
import { reduceToSingleArray } from '../helpers';
import Flex from '../../../atoms/Flex';
import Box from '../../../atoms/Box';
import LuContentButton from '../../../atoms/Button';
import LuContentItem from '../LuContentItem';
import { useLuContentContext } from '../LuContentContext';

const BlogLuHorizontalHighlightContent = ({
  onItemClick,
  onLoadMoreClick
}) => {
  const {
    data,
    linkToMoreContent
  } = useLuContentContext();
  const mergedArray = reduceToSingleArray(data);
  const highlightItems = mergedArray.filter(item => item.idx === 0);
  const contentItems = mergedArray.filter(item => item.idx !== 0);

  const getContentItems = highlightedItem => {
    return contentItems.filter(item => item.parentIdx === highlightedItem.parentIdx);
  };

  return /*#__PURE__*/React.createElement(Box, {
    bg: "background.lighter"
  }, /*#__PURE__*/React.createElement(ListContentContainer, {
    itemsSize: highlightItems.length,
    padding: "0 10px"
  }, highlightItems.map((itemHighlight, itemIndex) => /*#__PURE__*/React.createElement(Box, {
    key: itemHighlight.id,
    marginRight: highlightItems.length - 1 === itemIndex ? '0px' : '28px',
    width: "100%"
  }, /*#__PURE__*/React.createElement(LuContentItem, {
    vertical: true,
    itemsSize: highlightItems.length,
    data: itemHighlight,
    onItemClick: onItemClick,
    variation: "horizontal-highlight"
  }), getContentItems(itemHighlight).map(item => {
    return /*#__PURE__*/React.createElement(LuContentItem, {
      key: item.id,
      data: item,
      cover: true,
      onItemClick: onItemClick,
      variation: "horizontal-highlight"
    });
  })))), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    p: 3
  }, /*#__PURE__*/React.createElement(LuContentButton, {
    as: "a",
    variation: "outline",
    color: "luContent",
    centered: true,
    uppercase: false,
    href: linkToMoreContent,
    onClick: onLoadMoreClick
  }, "Veja outros conte\xFAdos")));
};

process.env.NODE_ENV !== "production" ? BlogLuHorizontalHighlightContent.propTypes = {
  onItemClick: func,
  onLoadMoreClick: func
} : void 0;
export default BlogLuHorizontalHighlightContent;